var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84.106,
    height: 121.024,
    viewBox: "103.112 51.6084 84.106 121.024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter06)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.202 86.7884C160.098 86.7884 159.202 85.893 159.202 84.7884V81.4164C159.202 77.2031 157.096 75.0964 152.882 75.0964H132.184C127.971 75.0964 125.864 77.2031 125.864 81.4164V103.918C125.864 105.562 127.832 106.407 129.024 105.274C135.134 99.4811 141.138 96.5844 147.036 96.5844H160.466C166.786 96.5844 172.158 98.7964 176.582 103.22C181.006 107.644 183.218 113.016 183.218 119.336V145.88C183.218 152.2 181.006 157.572 176.582 161.996C172.158 166.42 166.786 168.632 160.466 168.632H125.864C119.544 168.632 114.172 166.42 109.748 161.996C105.324 157.572 103.112 152.2 103.112 145.88V76.3604C103.112 70.0404 105.324 64.6684 109.748 60.2444C114.172 55.8204 119.544 53.6084 125.864 53.6084H159.202C165.522 53.6084 170.894 55.8204 175.318 60.2444C179.742 64.6684 181.954 70.0404 181.954 76.3604V84.7884C181.954 85.893 181.059 86.7884 179.954 86.7884H161.202ZM126.835 122.388C126.233 122.749 125.864 123.4 125.864 124.103V140.824C125.864 145.038 127.971 147.144 132.184 147.144H154.146C158.36 147.144 160.466 145.038 160.466 140.824V123.128C160.466 118.915 158.36 116.808 154.146 116.808H144.824C139.031 116.808 133.764 118.23 129.024 121.074L126.835 122.388Z",
    fill: "#4E0109"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.202 86.7884C160.098 86.7884 159.202 85.893 159.202 84.7884V81.4164C159.202 77.2031 157.096 75.0964 152.882 75.0964H132.184C127.971 75.0964 125.864 77.2031 125.864 81.4164V103.918C125.864 105.562 127.832 106.407 129.024 105.274C135.134 99.4811 141.138 96.5844 147.036 96.5844H160.466C166.786 96.5844 172.158 98.7964 176.582 103.22C181.006 107.644 183.218 113.016 183.218 119.336V145.88C183.218 152.2 181.006 157.572 176.582 161.996C172.158 166.42 166.786 168.632 160.466 168.632H125.864C119.544 168.632 114.172 166.42 109.748 161.996C105.324 157.572 103.112 152.2 103.112 145.88V76.3604C103.112 70.0404 105.324 64.6684 109.748 60.2444C114.172 55.8204 119.544 53.6084 125.864 53.6084H159.202C165.522 53.6084 170.894 55.8204 175.318 60.2444C179.742 64.6684 181.954 70.0404 181.954 76.3604V84.7884C181.954 85.893 181.059 86.7884 179.954 86.7884H161.202ZM126.835 122.388C126.233 122.749 125.864 123.4 125.864 124.103V140.824C125.864 145.038 127.971 147.144 132.184 147.144H154.146C158.36 147.144 160.466 145.038 160.466 140.824V123.128C160.466 118.915 158.36 116.808 154.146 116.808H144.824C139.031 116.808 133.764 118.23 129.024 121.074L126.835 122.388Z",
    fill: "url(#paint0)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter06",
    x: 103.112,
    y: 51.6084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.968627 0 0 0 0 0.921569 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow",
    result: "effect3_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0",
    x1: 143.165,
    y1: 53.6084,
    x2: 212.996,
    y2: 139.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.398452,
    stopColor: "#C40F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8102E",
    stopOpacity: 0.1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.54cb7613be7ccd6931e8b48a0a4e0507.svg";
export { ForwardRef as ReactComponent };